/* tslint:disable */

/**
 * Group name for events log filter:
 *   * TAG : The tag field
 *   * DESCRIPTION : The tag description field
 *   * DATE : The date field
 *   * VALUE : The value field
 *   * GROUP : The tag group field
 */
 type EventsLogFieldGroupTypeFull =
 'TAG' |
 'DESCRIPTION' |
 'DATE' |
 'LAST_DATE' |
 'COUNT_ACQUISITION' |
 'VALUE' |
 'GROUP';
const EventsLogFieldGroupTypeFull = (() => {
  const TAG: EventsLogFieldGroupTypeFull = 'TAG';
  const DESCRIPTION: EventsLogFieldGroupTypeFull = 'DESCRIPTION';
  const DATE: EventsLogFieldGroupTypeFull = 'DATE';
  const LAST_DATE: EventsLogFieldGroupTypeFull = 'LAST_DATE';
  const COUNT_ACQUISITION: EventsLogFieldGroupTypeFull = 'COUNT_ACQUISITION';
  const VALUE: EventsLogFieldGroupTypeFull = 'VALUE';
  const GROUP: EventsLogFieldGroupTypeFull = 'GROUP';
  function values(): EventsLogFieldGroupTypeFull[] {
    return [
      TAG,
      DESCRIPTION,
      DATE,
      LAST_DATE,
      COUNT_ACQUISITION,
      VALUE,
      GROUP
    ];
  }
  return { TAG, DESCRIPTION, DATE, LAST_DATE, COUNT_ACQUISITION, VALUE, GROUP, values };
})();

export { EventsLogFieldGroupTypeFull }